import services from './services';
import {
  lg,
  cloneDeep,
  util,
  isCorrectVal,
  isDate
} from 'utils';
import {
  GetProvinces,
  GetCitys,
  GetAreas,
} from '@api/commonApi.js';
import areaSelect from 'area-select';
export default {
  components: {
    areaSelect: areaSelect
  },
  mixins: [services],
  data() {
    return {
      lists: [],
      loading: false,
      pageIndex: 1,
      pageSize: 10,
      totalSize: '',
      pageSizes: [10, 20, 50],
      TotalClassNum: 0, //合计开班数
      TotalOpenClassNum: 0, //合计已开通班级数
      TotalBuyNum: 0, //合计另购数
      areaInfo: {
        Provinces_Id: null,
        City_Id: null
      },
      query: this.getFormData()

    }
  },
  methods: {
    getFormData() {
      return cloneDeep({
        AgentName: "", //代理商
        SchoolName: "", //园所
        ProvId: '',
        City_Id: ''
      });
    },
    //查询
    onQuerySubmit() {
      let areaForm = this.$refs.areaForm.getSelectedData();
      this.query.ProvId = areaForm.Provinces_Id;
      this.query.CityId = areaForm.City_Id;
      this.getList();
    },
    // 重置
    onQueryClean() {
      this.query = this.getFormData();
      this.$refs.areaForm.clearResultValue()
      this.getList();
    },
    //导出功能
    download() {
      this.$confirm('确认导出吗？', '提示', {}).then(() => {
        let params = {
          Sid: this.$store.state.sysSid,
          Session: this.$store.state.sysSession
        };
        let areaForm = this.$refs.areaForm.getSelectedData();
        this.query.ProvId = areaForm.Provinces_Id;
        this.query.CityId = areaForm.City_Id;
        params = Object.assign({}, params, util.getFormSearchParams(this.query));
        util.exportToFileV2("api/MeetOrder/GetMeetResourceExport", params, this)
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList()
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getList();
    }
  },
  created() {
    this.getList();

  },
}


// WEBPACK FOOTER //
// ./src/pages/Order/MeetOrederDetails/vm.js